"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Warning = function Warning(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.51,12.51,0,0,1,12.5,25Zm0-24A11.5,11.5,0,1,0,24,12.5,11.51,11.51,0,0,0,12.5,1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.24,13.81a1,1,0,0,0,.91.78h.7a.94.94,0,0,0,.91-.78l.85-6.17V5.2a.93.93,0,0,0-.91-.91H11.3a.92.92,0,0,0-.91.91V7.75Z",
    fill: "#e5332a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.48,16.13a2.31,2.31,0,0,0-2.26,2.3,2.28,2.28,0,0,0,4.56,0A2.31,2.31,0,0,0,12.48,16.13Z",
    fill: "#e5332a"
  }));
};

var _default = Warning;
exports["default"] = _default;